import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getPayment } from '../../services/payments';

function useGetPayment(paymentId: string | null | undefined) {
  const { user } = useUser();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['payment', paymentId, user?.userId],
    queryFn: async () => {
      const result = await getPayment({ paymentId: paymentId! });

      return result;
    },
    enabled: !!paymentId && !!user?.userId,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetPayment;
